import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '../../store/store';

type RequireAuthProps = {
  children: React.ReactNode;
};

/**
 * Route guard — redirects unauthenticated users to /login.
 * Checks both user presence and session expiry from the Zustand store.
 *
 * @component
 * @param {RequireAuthProps} props
 * @returns {JSX.Element}
 *
 * @example
 * <RequireAuth><Layout /></RequireAuth>
 */
const RequireAuth = ({ children }: RequireAuthProps) => {
  const user = useStore((state) => state.user);
  const sessionExpiry = useStore((state) => state.sessionExpiry);

  const isAuthenticated = !!user && !!sessionExpiry && sessionExpiry > Date.now();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
